export default "__VITE_ASSET__CwRrTE7L__"